<template>
  <div class="container">
    <BaseButtonBack></BaseButtonBack>

    <Section>
      <SectionInfo
        slot="info"
        :title="section.info.title"
        :text="section.info.text"
        :linkUrl="section.info.url"
      ></SectionInfo>
      <SectionCustomObjects
        slot="categories"
        :listLayout="section.listLayout"
        :allowDelete="true"
        :categories="customObjectsMapped"
      >
      <NewFieldButton slot="button" title="Add new custom object" @click.native="onAddNewObject"/>
      </SectionCustomObjects>
    </Section>

    <BaseHelpButton
      text="Learn more by reading our"
      icon="help"
      linkUrl="https://www.airfields.io/"
      linkLabel="documentation."/>
  </div>
</template>
<script>
import Store from '@/stores'
import Section from '@/components/Section'
import SectionInfo from '@/components/SectionInfo'
import SectionCategories from '@/components/SectionCategories'
import SectionCustomObjects from '@/components/SectionCustomObjects'
import NewFieldButton from '@/components/NewFieldButton'
import { mapGetters } from 'vuex'
import { MDSModalNewCustomObjectModel } from '@/models/modal-datasets.model'

export default {
  components: {
    Section,
    SectionInfo,
    SectionCategories,
    SectionCustomObjects,
    NewFieldButton
  },

  data () {
    return {
      section: {
        info: {
          title: 'Custom objects',
          text: '',
          url: ''
        },
        listLayout: true,
      },
    }
  },

  computed: {
    ...mapGetters('shopCustomobjectsgroupsManage', ['customObjectsMapped', 'usedObjectsKeys'])
  },

  methods: {
    onAddNewObject () {
      const props = new MDSModalNewCustomObjectModel({
        usedKeys: this.usedObjectsKeys
      })

      this.$store.commit('modals/OPEN_MODAL', { name: 'ModalNewCustomObject', props })
    },
    backToHomepage () {
      this.$router.push('/')
    }
  },

  async beforeRouteEnter(to, from, next){
    try {
        if (to.query.id) {
            Store.commit(`shopCustomobjectsgroupsManage/SET_ID`, { id: to.query.id })
        }
        let metafield = await Store.dispatch(`shopCustomobjectsgroupsManage/GET_SCHEMA_METAFIELD`)
        Store.commit(`shopCustomobjectsgroupsManage/SET_CUSTOM_OBJECTS_FROM_METAFIELD`, { metafield })
        next()
    } catch(error) {
        console.error(`Couldn't resolve ${to.name} beforeRouteEnter requests`, { error })
        next({
            name: 'app.error',
            query: { type: 'API' }
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/page-manage-customobjects.vue